import CanvasBase from "./_canvasBase.js";
import { color2Rgb } from "./helpers.js";
export default class Flow extends CanvasBase {
  onInit() {
    this.particles = Float32Array.from(
      { length: this.options.count * 3 },
      (_, i) =>
        this.random() *
        (i % 3 === 0 ? this.width : i % 3 === 1 ? this.height : Math.PI * 2),
    );
    this.lastT = undefined;
    this.fresh = true;
  }
  onResize() {
    this.fresh = true;
  }
  onMouseMove(x, y) {
    this.mx = x * this.width;
    this.my = y * this.height;
  }
  onUpdate() {
    const fresh = this.fresh;
    if (fresh) {
      this.clear();
      this.fresh = false;
    }
    const dt =
      fresh || this.lastT === undefined ? 1 : Math.min(3, this.t - this.lastT);
    this.lastT = this.t;
    if (dt <= 0) return;
    for (let step = 0; step < (fresh ? 28 : 1); step++) this.drawStep(dt);
  }
  onOptionsChange() {
    this.fresh = true;
  }
  drawStep(dt) {
    const c = this.context,
      o = this.options;
    c.save();
    c.globalCompositeOperation = "destination-out";
    c.fillStyle = "rgba(0,0,0,.075)";
    c.fillRect(0, 0, this.width, this.height);
    c.restore();
    for (let pass = 0; pass < 2; pass++) {
      c.strokeStyle = color2Rgb(pass ? o.color2 : o.color, 0.6);
      c.lineWidth = 0.8;
      c.beginPath();
      for (let i = pass * 3; i < this.particles.length; i += 6) {
        const x = this.particles[i],
          y = this.particles[i + 1],
          phase = this.particles[i + 2];
        const a =
          Math.sin(x * 0.004 + this.t * 0.002) +
          Math.cos(y * 0.005 - this.t * 0.001) +
          phase * 0.15;
        const d = Math.hypot(x - this.mx, y - this.my),
          v = 1.8 * o.intensity;
        const rx =
          (x - this.mx) *
          Math.exp(-d / 100) *
          0.01 *
          o.interactionStrength *
          (1 + this.pulse * 4);
        const ry =
          (y - this.my) *
          Math.exp(-d / 100) *
          0.01 *
          o.interactionStrength *
          (1 + this.pulse * 4);
        const nx = x + (Math.cos(a) * v + rx) * dt,
          ny = y + (Math.sin(a) * v + ry) * dt;
        c.moveTo(x, y);
        c.lineTo(nx, ny);
        this.particles[i] = (nx + this.width) % this.width;
        this.particles[i + 1] = (ny + this.height) % this.height;
      }
      c.stroke();
    }
  }
}
Flow.prototype.defaultOptions = {
  color: 0x4cd5c5,
  color2: 0x8278ea,
  backgroundColor: 0x07141e,
  count: 900,
  clickControls: true,
};
